var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPerson = function SvgIconPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.1 7.152a4.15 4.15 0 1 1-8.3 0 4.15 4.15 0 0 1 8.3 0m1 0a5.15 5.15 0 1 1-10.3 0 5.15 5.15 0 0 1 10.3 0M4.197 18.84c0-2.104 1.895-4.04 4.26-4.04h7.08c2.365 0 4.26 1.936 4.26 4.04v.762c-.006.734-.669 1.399-1.563 1.399H5.76c-.903 0-1.563-.666-1.563-1.404zm4.26-5.04c-2.888 0-5.26 2.355-5.26 5.04v.757c0 1.364 1.184 2.404 2.563 2.404h12.474c1.372 0 2.554-1.04 2.563-2.393v-.768c0-2.685-2.372-5.04-5.26-5.04z",
    clipRule: "evenodd"
  })));
};
export default SvgIconPerson;